import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from "html-react-parser";
// import ReplayItem from "./ReplayItem";

class CustomerNoticeItemNew extends Component {
  state = {
    showDetail: false,
    mouseOver: false,
  };
  _toggleDetail = () => {
    const { showDetail } = this.state;
    this.setState({
      showDetail: !showDetail,
    });
  };
  _onDelete = () => {
    const { idx, onItemDel } = this.props.childProps;
    ////console.log(idx)
    confirmAlert({
      title: "삭제",
      message: "삭제된 글은 복구되지 않습니다. 글을 삭제 하시겠니까? ",
      buttons: [
        {
          label: "삭제",
          onClick: () => {
            //alert(0)
            onItemDel(idx);
          },
        },

        {
          label: "취소",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  _toggleMouse = () => {
    const { mouseOver } = this.state;
    this.setState({
      mouseOver: !mouseOver,
    });
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _goItem = () => {
    // const { setBoardIdx } = this.props;
    // const { idx } = this.props.childProps;
    //setBoardIdx(idx)
  };
  _toggleSelect = (index, idx) => {
    const { _selected } = this.props.childProps;

    _selected(index, idx);
  };
  render() {
    // const { loginId } = this.props;
    // const { showDetail, mouseOver } = this.state;
    const {
      index,
      idx,

      title,
      writeDay,
      content,
      selected,
    } = this.props.childProps;

    return (
      <Fragment>
        <ul>
          <li className="date">{writeDay}</li>
          <li className="info">
            <p className="subject" onClick={this._goItem}>
              {title}
            </p>
            <div className="con">{parse(content)}</div>
          </li>
          <input
            type="checkbox"
            className="chkBox"
            name="chk"
            id={"chk" + index}
            checked={selected > 0 ? true : false}
            onChange={() => this._toggleSelect(index, idx)}
          />
          <label htmlFor={"chk" + index} className="chk"></label>
        </ul>

        {/*
                <tr className={ mouseOver ? "h_over" : null }>
                    <td>{this._CommaFormatted(numm)}</td>
                    <td>
                    <span className={ chkNotice ? "icon notice" : categoryID === 1 ? "icon vod" : categoryID === 2 ? "icon membership" : categoryID === 5 ? "icon delivery" : categoryID === 101 ? "icon shipping" : categoryID === 12 ? "icon event" : categoryID === 11 ? "icon etc" : 'icon etc'}>{categoryName === '' ? '미분류' : chkNotice ? '공지' : categoryName}</span>
                    </td>
                    <td className="txt">
                        {loginId === 'admin' ? (<span style={{color: 'orange'}}>{nicName + '(' + userid + ')'}</span>) : null }
                        <a style={{cursor: 'pointer'}}  onMouseEnter={this._toggleMouse} onMouseLeave={this._toggleMouse} onClick={this._goItem}>{title}</a>
                        {loginId === userid || loginId === 'admin' ? <span onClick={this._onDelete} style={{color: 'blue', position: 'absolute', right: 100, cursor: 'pointer'}}>[삭제]</span> : null } {board_id === 9 ? replay_idx === 0 ? null : (<span style={{color: 'red'}}>[답변완료]</span>) : null }
                    </td>
                    <td>
                        {writeDay}
                    </td>
                </tr>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CustomerNoticeItemNew));
